import { Resource } from '@topconagriculture/permissions';
import { WidgetFooterType, WidgetHeaderType, WidgetSize, WidgetType } from '../widget.types';
import { widgetSizeEditModalName } from '../WidgetConfig';
export const DeliverDeviationWidgetConfig = {
    type: WidgetType.DELIVER_DEVIATION,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/deliver-deviation.jpg',
    title: 'widget:deliver_deviation:title',
    description: 'widget:deliver_deviation:description',
    permissions: [Resource.FEED_WIDGET_PEN_DELIVER_DEVIATION],
    header: () => ({
        type: WidgetHeaderType.GENERIC,
        actions: [
            {
                title: 'common:settings',
                modal: widgetSizeEditModalName,
            },
        ],
    }),
    footer: () => ({
        type: WidgetFooterType.EMPTY,
        href: '',
        text: '',
    }),
    baseConfig: {
        type: WidgetType.DELIVER_DEVIATION,
        w: 2,
        h: 2,
        x: 0,
        y: 0,
    },
    init: () => {
        return {
            type: WidgetType.DELIVER_DEVIATION,
            config: { size: WidgetSize.XS },
            w: 2,
            h: 2,
            minW: 2,
            minH: 2,
            x: 0,
            y: 0,
        };
    },
};
//# sourceMappingURL=DeliverDeviationWidgetConfig.js.map